<aside class="sidebar" [class.open]="!sidebar.isCollapsed()" [class.collapsed]="sidebar.isCollapsed()">
  <ul class="nav flex-column">
    @for (option of options(); track option.label) {
      <li class="nav-item">
        <div>
          <a class="nav-link d-flex align-items-center"
            [routerLink]="option.route"
            routerLinkActive="active"
            [ngClass]="{
              'justify-content-center': sidebar.isCollapsed(),
              'active': sidebar.isCollapsed() && isParentActive(option)
            }"
            (click)="toggleSubmenu(option)">
            <i [class]="option.icon" [title]="option.label"></i>
            @if (!sidebar.isCollapsed()) {
              <span class="ms-2">{{ option.label }}</span>
            }
            @if (option.children && !sidebar.isCollapsed()) {
              <i class="bi ms-auto"
                [ngClass]="isSubmenuOpen(option) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            }
          </a>

          @if (option.children && isSubmenuOpen(option) && !sidebar.isCollapsed()) {
            <ul class="nav flex-column ms-4">
              @for (child of option.children; track child.label) {
                <li class="nav-item">
                  <a class="nav-link d-flex align-items-center"
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"
                  >
                    <i [class]="child.icon"></i>
                    <span class="ms-2">{{ child.label }}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </div>
      </li>
    }
  </ul>
</aside>
